// ES6 Modules or TypeScript
import Swal from 'sweetalert2/dist/sweetalert2';
import settings from './settings';

export default function Alert(options) {
  return Swal.fire({
    ...settings,
    ...options,
  });
}
